import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as BellIcon } from "../../assects/svg/dashboard/bell.svg";
import { Button } from "./Button";

interface PageHeaderProps {
  title: string | React.ReactNode;
  breadcrumb?: string;
  breadcrumbLinks?: string[];
  rightContent?: React.ReactNode;
  showSendForApproval?: boolean;
  onSendForApproval?: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  breadcrumb,
  breadcrumbLinks,
  rightContent,
  showSendForApproval = false,
  onSendForApproval,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBellClick = () => {
    console.log("Bell icon clicked - notifications will be implemented here");
  };

  const handleBreadcrumbClick = (index: number) => {
    if (breadcrumbLinks && breadcrumbLinks[index]) {
      // Forward the current location.state so isDeactivated (and any other
      // flags) survive navigation back through the breadcrumb chain.
      navigate(breadcrumbLinks[index], { state: location.state });
    }
  };

  const handleSendForApproval = () => {
    if (onSendForApproval) {
      onSendForApproval();
    }
  };

  const renderBreadcrumb = () => {
    if (!breadcrumb) return null;

    const parts = breadcrumb.split(" > ").map((part) => part.trim());

    return (
      <div className="flex items-center gap-1 text-[10px] 2xl:text-[12px] font-inter font-medium">
        {parts.map((part, index) => (
          <React.Fragment key={index}>
            {breadcrumbLinks && breadcrumbLinks[index] ? (
              <button
                onClick={() => handleBreadcrumbClick(index)}
                className="text-[#646464] hover:text-[#0DB5B5] transition-colors"
              >
                {part}
              </button>
            ) : (
              <span className="text-[#646464]">{part}</span>
            )}
            {index < parts.length - 1 && (
              <span className="text-[#646464] mx-1">{">"}</span>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <header className="px-4 sm:px-6 lg:px-8 pt-6 pb-4 flex-shrink-0">
      <div className="flex justify-between items-center">
        <div>
          {typeof title === "string" ? (
            <h1 className="text-xl sm:text-xl 3xl:text-2xl font-bold font-inter text-[#1F1F1F]">
              {title}
            </h1>
          ) : (
            <div className="text-xl sm:text-xl 3xl:text-2xl font-bold font-inter text-[#1F1F1F]">
              {title}
            </div>
          )}
          {renderBreadcrumb()}
        </div>
        <div className="flex items-center gap-3">
          {rightContent}
          {showSendForApproval && (
            <Button
              variant="primary"
              onClick={handleSendForApproval}
            >
              Send to client
            </Button>
          )}
          {/* <button
            onClick={handleBellClick}
            className="hover:opacity-80 transition-opacity"
            aria-label="Notifications"
          >
            <BellIcon className="w-5 h-5 sm:w-6 sm:h-6" />
          </button> */}
        </div>
      </div>
    </header>
  );
};

export default PageHeader;